<style lang="scss" scoped>
.page-employee-insurance {
    .short-input {
        width: 120px;
    }
    .short-range {
        width: 240px;
    }
    .op-btn {
        width: 84px;
        padding-left: 0;
        padding-right: 0;
    }
    .person-link {
        color: #409eff;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
    .insurance-import-result p {
        margin: 0 0 10px;
        line-height: 1.7;
    }
}
</style>

<template>
    <div class="page-employee-insurance">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <!-- 保单数据：导入/维护保单主档（保单数据量少，放弹框统一管理） -->
                    <el-button class="mrgr5 mrgb5" type="danger" size="medium" @click="openPolicyDialog()">
                        <i class="fa fa-file-text-o"></i> 保单数据
                    </el-button>
                    <!-- 员工保险 JSON 导入（按 身份证+保单号+开始日期 新增/更新） -->
                    <el-upload class="dib mrgr5 mrgb5" action="#" accept=".json,application/json"
                        :http-request="uploadInsuranceImport" :show-file-list="false" :disabled="importingInsurance">
                        <el-button type="success" size="medium" :loading="importingInsurance">
                            <i class="fa fa-sign-in"></i> 导入保险
                        </el-button>
                    </el-upload>
                    <!-- 员工保险 JSON 导出（可直接回导） -->
                    <el-button class="mrgr5 mrgb5" type="success" size="medium" plain @click="exportInsuranceJson()">
                        <i class="fa fa-sign-out"></i> 导出保险
                    </el-button>
                </div>
                <div class="fr">
                    <!-- 保险结束时间范围 -->
                    <el-tag type="info" class="mrgr5">按保险结束时间范围：</el-tag>
                    <el-date-picker class="mrgr5 mrgb5 short-range" v-model="dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size="medium"
                        value-format="yyyy-MM-dd" @change="changeDateRange">
                    </el-date-picker>
                    <!-- 员工在职状态（0 = 未建档：身份证号没有对应档案） -->
                    <el-select class="c-el-input mrgr5 mrgb5 short-input" v-model="listQuery.employeeStatus"
                        placeholder="员工状态" clearable size="medium" @change="_search()">
                        <el-option label="在职" :value="1"></el-option>
                        <el-option label="离职" :value="2"></el-option>
                        <el-option label="未建档" :value="0"></el-option>
                    </el-select>
                    <!-- 需购保险：需购买 = 在职且需购且无有效保障（无保险/已过期/即将到期）；免投保 = 货运/无票 -->
                    <el-select class="c-el-input mrgr5 mrgb5 short-input" v-model="listQuery.needBuy"
                        placeholder="需购保险" clearable size="medium" @change="_search()">
                        <el-option label="需购买" :value="true"></el-option>
                        <el-option label="免投保" :value="false"></el-option>
                    </el-select>
                    <!-- 保险状态 -->
                    <el-select class="c-el-input mrgr5 mrgb5 short-input" v-model="listQuery.insuranceState"
                        placeholder="保险状态" clearable size="medium" @change="_search()">
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="即将到期" :value="2"></el-option>
                        <el-option label="已过期" :value="3"></el-option>
                        <el-option label="无保险" :value="4"></el-option>
                    </el-select>
                    <!-- 搜索内容 -->
                    <el-input class="c-el-input mrgr5 mrgb5" placeholder="姓名/身份证号/手机号/保单号" clearable v-model="listQuery.keywords"
                        size="medium" @keyup.enter.native="_search()"></el-input>
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                    <el-button class="mrgb5" type="warning" size="medium" @click="openExportDialog()">
                        <i class="fa fa-file-excel-o"></i> 导出Excel
                    </el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <!-- 数据表格 -->
            <el-table :data="tableData" style="width: 100%" border size="small">
                <el-table-column label="姓名" prop="name" width="100">
                    <template slot-scope="scope">
                        <!-- 有档案时点击弹出：员工档案 / 入职离职记录 -->
                        <el-dropdown v-if="scope.row.archiveId" trigger="click"
                            @command="handlePersonCommand($event, scope.row)">
                            <span class="person-link">{{ scope.row.name }}</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="archive"><i class="fa fa-address-card-o"></i> 员工档案</el-dropdown-item>
                                <el-dropdown-item command="records"><i class="fa fa-history"></i> 入职离职记录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-else>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="身份证号" prop="idNumber" min-width="160">
                    <template slot-scope="scope">
                        <el-dropdown v-if="scope.row.archiveId" trigger="click"
                            @command="handlePersonCommand($event, scope.row)">
                            <span class="person-link">{{ scope.row.idNumber }}</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="archive"><i class="fa fa-address-card-o"></i> 员工档案</el-dropdown-item>
                                <el-dropdown-item command="records"><i class="fa fa-history"></i> 入职离职记录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-else>{{ scope.row.idNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="用工类型" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.employmentType || "-" }}</span>
                        <!-- 用工类型为货运/无票的免投保，运营无需为其购买保险 -->
                        <el-tag class="mrgl5" size="mini" type="info"
                            v-if="scope.row.employmentType && scope.row.needInsurance === false">免投保</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="保单号" prop="policyNumber" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="保险公司" prop="insuranceCompany" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="被保人" prop="insuredName" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="承保支公司" prop="underwritingBranch" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="保险开始时间" prop="startDate" :formatter="formatDate" width="115"></el-table-column>
                <el-table-column label="保险结束时间" prop="effectiveEndDate" :formatter="formatDate" width="115"></el-table-column>
                <el-table-column label="保险状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="medium" type="success" v-if="scope.row.insuranceState === 1">{{ scope.row.insuranceStateDesc }}</el-tag>
                        <el-tag size="medium" type="warning" v-if="scope.row.insuranceState === 2">{{ scope.row.insuranceStateDesc }}</el-tag>
                        <el-tag size="medium" type="danger" v-if="scope.row.insuranceState === 3">{{ scope.row.insuranceStateDesc }}</el-tag>
                        <!-- 档案驱动：名下没有任何保险绑定的员工显示无保险 -->
                        <el-tag size="medium" type="danger" v-if="scope.row.insuranceState === 4">{{ scope.row.insuranceStateDesc || '无保险' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="员工状态" width="100" align="center">
                    <template slot-scope="scope">
                        <!-- 员工状态按关联档案的最后工作日实时判定，未建档显示灰色 -->
                        <el-tag size="medium" type="success" v-if="scope.row.employeeStatus === 1 && !scope.row.archiveLeaveDate">在职</el-tag>
                        <el-tag size="medium" type="warning" v-if="scope.row.employeeStatus === 1 && scope.row.archiveLeaveDate">待离职</el-tag>
                        <el-tag size="medium" type="info" v-if="scope.row.employeeStatus === 2">离职</el-tag>
                        <el-tag size="medium" type="info" v-if="!scope.row.employeeStatus">未建档</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="绑定数" width="76" align="center">
                    <template slot-scope="scope">{{ scope.row.historyCount }}</template>
                </el-table-column>
                <el-table-column label="操作" width="110" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="op-btn" plain size="mini" @click="viewHistory(scope.row)">全部绑定</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" v-if="isPagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 保单数据弹框 -->
        <employee-policy-dialog ref="employeePolicyDialog" @changed="_searchKeepPage()"></employee-policy-dialog>
        <!-- 导出对话框 -->
        <employee-insurance-export-dialog ref="employeeInsuranceExportDialog" :query="listQuery"
            :max-export-count="maxExportCount"></employee-insurance-export-dialog>
        <!-- 员工档案详情（姓名/身份证下拉-员工档案） -->
        <employee-archive-detail ref="employeeArchiveDetail"></employee-archive-detail>
        <!-- 入离职记录（姓名/身份证下拉-入职离职记录） -->
        <employee-records ref="employeeRecords"></employee-records>
        <!-- 按人查保险历史 -->
        <employee-insurance-history ref="employeeInsuranceHistory"></employee-insurance-history>
        <!-- 员工保险导入结果 -->
        <el-dialog title="员工保险导入结果" :visible.sync="importResultVisible"
            custom-class="c-el-dialog comp-employee-insurance-import-dialog">
            <div class="insurance-import-result" v-if="importResult">
                <p>总数 {{ importResult.totalCount }} · 新增 {{ importResult.addedCount }} · 更新
                    {{ importResult.updatedCount }} · 跳过 {{ importResult.skippedCount }}</p>
                <el-table :data="importResult.errors || []" style="width: 100%" max-height="320" border size="small"
                    empty-text="无跳过明细">
                    <el-table-column prop="row" label="行号" width="80"></el-table-column>
                    <el-table-column prop="message" label="跳过原因" min-width="300"></el-table-column>
                </el-table>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="importResultVisible = false">知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import permission from "@/mixins/permission"
import configMixins from "@/mixins/config"
import * as funEmployee from "@/api/employees"
import saveAs from "file-saver"
import moment from "moment"
import EmployeePolicyDialog from "./components/employeePolicyDialog"
import EmployeeInsuranceExportDialog from "./components/EmployeeInsuranceExportDialog"
import employeeArchiveDetail from "./components/employeeArchiveDetail"
import employeeRecords from "./components/employeeRecords"
import employeeInsuranceHistory from "./components/employeeInsuranceHistory"

export default {
    name: "pageEmployeeInsurance",
    mixins: [permission, configMixins],
    components: { EmployeePolicyDialog, EmployeeInsuranceExportDialog, employeeArchiveDetail, employeeRecords, employeeInsuranceHistory },
    data() {
        return {
            tableData: [],
            total: null,
            // 日期范围（保险结束时间）
            dateRange: [],
            listQuery: {
                keywords: "",
                beginDate: "",
                endDate: "",
                employeeStatus: null,
                // 需购保险筛选：true=需购买（在职且需购且无有效保障），false=免投保（货运/无票）
                needBuy: null,
                // 保险状态：1 正常 / 2 即将到期 / 3 已过期 / 4 无保险
                insuranceState: null,
                page: 1,
                size: window.$common.appPageSize
            },
            isPagination: false,
            // 员工保险 JSON 导入
            importingInsurance: false,
            importResult: null,
            importResultVisible: false
        }
    },
    mounted() {
        this.getDataList()
    },
    methods: {
        // 保险结束日期范围改变
        changeDateRange(val) {
            if (val) {
                this.listQuery.beginDate = val[0]
                this.listQuery.endDate = val[1]
            } else {
                this.listQuery.beginDate = ""
                this.listQuery.endDate = ""
            }
            this._search()
        },
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        // 获取数据列表（员工保单绑定，含保单主档与员工档案关联信息）
        getDataList() {
            window.$common.fullLoading()
            let params = JSON.parse(JSON.stringify(this.listQuery))
            funEmployee.GetEmployeeInsuranceBindings(params).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                this.tableData = (response && response.items) || []
            })
        },
        // 保单变化后刷新当前页（不重置页码）
        _searchKeepPage() {
            this.getDataList()
        },
        // 员工保险 JSON 导入（按 身份证+保单号+开始日期 新增/更新）
        uploadInsuranceImport(option) {
            const file = option.file
            if (!/\.json$/i.test(file.name)) {
                this.alert("请选择 JSON 文件！")
                return
            }
            this.importingInsurance = true
            window.$common.fullLoading()
            funEmployee.ImportEmployeeInsuranceBindings(file).then(response => {
                window.$common.closeFullLoading()
                this.importResult = response
                this.importResultVisible = true
                this.getDataList()
            }).catch(() => {
                window.$common.closeFullLoading()
            }).finally(() => {
                this.importingInsurance = false
            })
        },
        // 员工保险 JSON 导出（按当前筛选条件导出全部，可直接回导）
        exportInsuranceJson() {
            window.$common.fullLoading()
            const params = JSON.parse(JSON.stringify(this.listQuery))
            delete params.page
            delete params.size
            funEmployee.ExportEmployeeInsuranceBindings(params).then(response => {
                window.$common.closeFullLoading()
                saveAs(response, `员工保险_${moment().format("YYYYMMDDHHmmss")}.json`)
            }).catch(() => {
                window.$common.closeFullLoading()
            })
        },
        // 日期格式化（空值显示空白）
        formatDate(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD") : ""
        },
        // 姓名/身份证下拉：查看员工档案或入离职记录（未建档不显示下拉）
        handlePersonCommand(command, row) {
            if (command === "archive") {
                this.$refs.employeeArchiveDetail.open({ id: row.archiveId })
            } else if (command === "records") {
                this.$refs.employeeRecords.open({ idNumber: row.idNumber, name: row.name })
            }
        },
        // 按人查保险历史（名下全部绑定含过期/续保）
        viewHistory(row) {
            this.$refs.employeeInsuranceHistory.open(row)
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        openPolicyDialog() {
            this.$refs.employeePolicyDialog.open()
        },
        openExportDialog() {
            this.$refs.employeeInsuranceExportDialog.open()
        }
    }
}
</script>
